import React, { useState } from "react";


import {
  FaCar,
  FaChevronDown,
  FaChevronUp,
  FaCheck,
} from "react-icons/fa";

const RESPONSIVE_CSS = `
  .aip-hero-inner {
    width: 92% !important;
    padding: 38px 0px !important;
  }
  .aip-hero-icon {
    width: 44px !important;
    height: 44px !important;
  }
  .aip-hero-title {
    font-size: clamp(22px, 5vw, 34px) !important;
  }
  .aip-hero-desc {
    font-size: clamp(13px, 2vw, 15px) !important;
    line-height: 1.8 !important;
  }
  .aip-accordion-wrap {
    width: 92% !important;
    padding: 28px 0px 50px !important;
  }
  .aip-accordion-header {
    padding: 14px 16px !important;
    gap: 10px !important;
  }
  .aip-accordion-title {
    font-size: 15px !important;
  }
  .aip-accordion-content {
    padding: 16px 18px !important;
  }
  .aip-point-text {
    font-size: 14px !important;
  }

  @media (max-width: 600px) {
    .aip-hero-inner {
      width: 90% !important;
      padding: 28px 0px !important;
    }
    .aip-hero-row {
      gap: 10px !important;
      margin-bottom: 12px !important;
    }
    .aip-hero-icon {
      width: 38px !important;
      height: 38px !important;
      border-radius: 8px !important;
    }
    .aip-hero-icon svg {
      font-size: 17px !important;
    }
    .aip-hero-title {
      font-size: clamp(19px, 6vw, 26px) !important;
    }
    .aip-hero-desc {
      font-size: 13px !important;
      line-height: 1.7 !important;
    }
    .aip-accordion-wrap {
      width: 92% !important;
      padding: 20px 0px 36px !important;
    }
    .aip-accordion-header {
      padding: 12px 14px !important;
    }
    .aip-accordion-title {
      font-size: 14px !important;
      line-height: 1.4 !important;
    }
    .aip-accordion-content {
      padding: 14px 14px !important;
    }
    .aip-point-row {
      gap: 10px !important;
      margin-bottom: 10px !important;
    }
    .aip-point-check {
      width: 20px !important;
      height: 20px !important;
      min-width: 20px !important;
    }
    .aip-point-check svg {
      font-size: 9px !important;
    }
    .aip-point-text {
      font-size: 13px !important;
      line-height: 1.6 !important;
    }
  }

  @media (max-width: 360px) {
    .aip-hero-title {
      font-size: 18px !important;
    }
    .aip-accordion-title {
      font-size: 13px !important;
    }
  }
`;

function AutomotiveIndustryPage() {
  const [openIndex, setOpenIndex] = useState(null);

  const toggle = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const sections = [
    {
      title: "Autonomous Driving & Driver Assistance",
      points: [
        "Autonomous Navigation Agent",
        "Driver Monitoring Agent",
        "Adaptive Cruise Control Agent",
        "Lane-Keeping & Change Agent",
        "Collision Avoidance Agent",
      ],
    },

    {
      title: "Manufacturing & Production",
      points: [
        "Predictive Maintenance Agent",
        "Defect Detection Agent (Vision AI)",
        "Quality Control Agent",
        "Production Scheduling Agent",
        "Supply Chain Optimization Agent",
      ],
    },

    {
      title: "Engineering & Design",
      points: [
        "Generative Design Agent",
        "Simulation & Crash-Test Agent",
        "ECU Configuration Agent",
        "Digital Twin Agent",
        "Battery Management Agent (EVs)",
      ],
    },

    {
      title: "Logistics & Fleet Management",
      points: [
        "Fleet Routing & Dispatch Agent",
        "Telematics Monitoring Agent",
        "EV Charging Optimization Agent",
        "Warehouse Automation Agent",
      ],
    },

    {
      title: "Sales, Aftermarket & Customer Service",
      points: [
        "Personalized Sales Assistant Agent",
        "Virtual Service Agent",
        "Warranty Claim Processing Agent",
        "Smart Recall Management Agent",
        "Voice-Activated In-Car Agent",
        "Insurance Claim Assessment Agent",
      ],
    },
  ];

  return (
    <>
      <style>{RESPONSIVE_CSS}</style>

      <div
        style={{
          background: "#22c7b8",
          minHeight: "100vh",
          overflowX: "hidden",
        }}
      >
        {/* HERO SECTION */}
        <div
          style={{
            background: "#173b8f",
            width: "100%",
          }}
        >
          <div
            className="aip-hero-inner"
            style={{
              width: "92%",
              maxWidth: "1300px",
              margin: "0 auto",
              padding: "38px 0px",
              boxSizing: "border-box",
            }}
          >
            <div
              className="aip-hero-row"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "12px",
                marginBottom: "16px",
                flexWrap: "wrap",
              }}
            >
              <div
                className="aip-hero-icon"
                style={{
                  width: "44px",
                  height: "44px",
                  background: "#22c7b8",
                  borderRadius: "10px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  flexShrink: 0,
                }}
              >
                <FaCar
                  style={{
                    color: "#ffffff",
                    fontSize: "20px",
                  }}
                />
              </div>

              <h1
                className="aip-hero-title"
                style={{
                  color: "#ffffff",
                  fontSize: "34px",
                  fontWeight: "700",
                  margin: 0,
                  fontFamily: "Exo, sans-serif",
                  wordBreak: "break-word",
                }}
              >
                The Automotive Industry
              </h1>
            </div>

            <p
              className="aip-hero-desc"
              style={{
                color: "#f2f2f2",
                fontSize: "15px",
                lineHeight: "1.9",
                maxWidth: "1000px",
                margin: 0,
              }}
            >
              This sector focuses on the design, development,
              manufacturing, and sale of motor vehicles. It is rapidly
              evolving with trends like electric vehicles (EVs),
              autonomous driving, connected cars, and smart
              manufacturing — making it fertile ground for AI agents
              to enhance safety, productivity, and user experience.
            </p>
          </div>
        </div>

        {/* ACCORDION SECTION */}
        <div
          className="aip-accordion-wrap"
          style={{
            width: "78%",
            maxWidth: "1050px",
            margin: "0 auto",
            padding: "28px 0px 50px",
            boxSizing: "border-box",
          }}
        >
          {sections.map((section, index) => (
            <div
              key={index}
              style={{
                background: "#ffffff",
                borderRadius: "8px",
                marginBottom: "10px",
                overflow: "hidden",
                boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
              }}
            >
              {/* HEADER */}
              <div
                onClick={() => toggle(index)}
                className="aip-accordion-header"
                style={{
                  padding: "14px 18px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  cursor: "pointer",
                  background:
                    openIndex === index
                      ? "#173b8f"
                      : "#ffffff",
                  transition: "0.3s",
                  gap: "12px",
                  boxSizing: "border-box",
                }}
              >
                <h2
                  className="aip-accordion-title"
                  style={{
                    margin: 0,
                    fontSize: "16px",
                    fontWeight: "700",
                    color:
                      openIndex === index
                        ? "#ffffff"
                        : "#173b8f",
                    fontFamily: "Exo, sans-serif",
                    wordBreak: "break-word",
                    minWidth: 0,
                  }}
                >
                  {section.title}
                </h2>

                {openIndex === index ? (
                  <FaChevronUp
                    style={{
                      color: "#ffffff",
                      fontSize: "16px",
                      flexShrink: 0,
                    }}
                  />
                ) : (
                  <FaChevronDown
                    style={{
                      color: "#173b8f",
                      fontSize: "16px",
                      flexShrink: 0,
                    }}
                  />
                )}
              </div>

              {/* CONTENT */}
              {openIndex === index && (
                <div
                  className="aip-accordion-content"
                  style={{
                    padding: "18px 24px",
                    background: "#ffffff",
                    boxSizing: "border-box",
                  }}
                >
                  {section.points.map((point, i) => (
                    <div
                      key={i}
                      className="aip-point-row"
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                        marginBottom: "12px",
                      }}
                    >
                      <div
                        className="aip-point-check"
                        style={{
                          width: "24px",
                          height: "24px",
                          minWidth: "24px",
                          borderRadius: "50%",
                          background: "#22c7b8",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                        }}
                      >
                        <FaCheck
                          style={{
                            color: "#ffffff",
                            fontSize: "10px",
                          }}
                        />
                      </div>

                      <p
                        className="aip-point-text"
                        style={{
                          margin: 0,
                          color: "#4b5563",
                          fontSize: "15px",
                          lineHeight: "1.7",
                          fontWeight: "500",
                          wordBreak: "break-word",
                        }}
                      >
                        {point}
                      </p>
                    </div>
                  ))}
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </>
  );
}

export default AutomotiveIndustryPage;
